<template>
  <div id="aboutme-tech">
    <div class='sequence aboutme-deail-title' transition='fromRight' >Creative Technologist / Software Engineer / Ceramist</div>
    <div class='sequence aboutme-detail-exerpt' transition='fromRight' >
      <p>
        I like to bring imagination to tangible experience.
      </p>
    </div>
    <div class='sequence aboutme-detail-content' transition='fromBottom' >
      <p>
        I have been working as <a href="http://www.emogayu.com" target="_new"><span class="c-title">ceramist</span></a> for 
        18 years. All my installation are done in the spaces with the history to tell for its self at around neighborhood.
        I believe my works are to be used and grow older with people who uses. 
      </p>
      <p>
        For an indivisual projects as a <a href="https://www.instagram.com/airinterface.yuri/" target="_new"><span class="c-title">Tecnologist</span></a>, I'm producing STEAM prototypes, IOT, wearable products. I also love working with artists to create their artwork come alive. 
      </p>
      <p>I worked as  
        <a href="https://www.linkedin.com/in/yuri-fukuda-a17919196/" target="_new"><span class="c-title">R&D Lead Senior Software Engineer</span></a>. I research and introduces new technology and create
        modules for cross platform apps in the no-code studio which I developed. i.e. XR, IOT, AI integration for museum and retail solutions. 
      <p>
        Using technology, I love to serve people ( adults and kids ) with imagination to build professional apps / technical architecture by developing platforms at EachScape, Inc.
      </p>
      <p>
        I'm skilled engineer developing localization solution for an international project. 
        I've worked on the first Motola Razer phone development that involved Japanese customizattion for the phone career and 
        global feature localization working with the international teams.
      </p>
    </div>


  </div>
</template>

<script>
  import gsap from "gsap";

  const currentTweens = [];
  const initSequence = [
    async function(){
      this.invalidatePreviousTransition();
      jQuery( ".sequence[transition='fromRight']" ).attr("style", "");
      const tw = await gsap
        .from(".sequence[transition='fromRight']", {
          duration: 1,
          x: 100,
          opacity: 0,
          ease: "power2.inOut",
          stagger: 0.3,
          clearProps: "transform,opacity"
        });
      currentTweens.push(tw);
    }
  ];

  const destroySequence = [
    async function(){
      this.invalidatePreviousTransition();
      const tw = await gsap
        .to(".sequence[transition='fromRight']", {
          duration: 1,
          opacity: 0,
          x: -100,
          ease: "power2.inOut",
          clearProps: "all"
        });
      currentTweens.push(tw);
    }
  ];


  export default {
    props: ['active'],
    mounted(){
      console.log('about me mounted');
    },
    methods: {
      activate(){
        const _initSequence = initSequence;
        this.runSyncFunction( _initSequence );
      },
      deactivate(){
        console.log('deactivate!');
        const _destroySequence = destroySequence;
        this.runSyncFunction( _destroySequence );
      },
      invalidatePreviousTransition(){
        while( currentTweens.length > 0  ) {
          const tw = currentTweens.splice(0,1)[0]
          tw.invalidate();
        }
      },
      runSyncFunction( funcs = [] ){
        if( funcs.length == 0 ) return;
        const f = funcs[0];
        return f.call(this);
      }
    },
    watch: {
      active: function(){
        if( this.active == true ) {
          this.activate();
        } else {
          this.deactivate();
        }

      }
    }
  }

</script>

     
<style lang="scss">
  #aboutme-tech{
    box-sizing: border-box;
    overflow-y:auto;
    overflow-x:hidden;

    position:absolute;
    top:0px;
    left:0px;
    width: 100%;
    height: 100%;
    padding: 1.5em;
    .sequence {
      opacity: 1;
      width: 50vw;
      left: 100%;
      > p {
        line-height: 1.2em;
        .c-title {
          text-transform: uppercase;
          font-size: 1.2em;
        }
      }
    }
    .aboutme-deail-title{
      font-size: 2em;
      font-style: italic;
    }

    .sequence.aboutme-detail-exerpt{
      font-size: 1.5em;
      margin-top: 2em;
      & > p{
        line-height: 1.2em;
      }
    }

    .sequence.aboutme-detail-content{
      font-size: 1em;
      & > p {
        line-height: 1.5em;
      }
    }

  }
</style>